import { Flow_Condition__Input } from '~/graphql/types';
import { FlowConditionAppBBWaardecheckContactRequestNew } from './types.flow';
import { asEventParameterValueInput } from '~/scenes/Automation/Flows/Actions/Base/FlowParameter/ParameterValue/Event';

const asFlowConditionAppBBWaardecheckContactRequestNewInput = (
  condition: FlowConditionAppBBWaardecheckContactRequestNew,
): Flow_Condition__Input => {
  const { event } = condition;

  return {
    EventContactApp: {
      BBWaardecheck: {
        ContactRequest: {
          New: {
            event: event ? asEventParameterValueInput(event) : null,
          },
        },
      },
    },
  };
};

export default asFlowConditionAppBBWaardecheckContactRequestNewInput;
